import { BaseModel } from '../core/abstractions/base.model';

export class ChatMessageModel extends BaseModel {
    sendTime: Date;
    readTime?: Date;
    shareholderId: any;
    shareholderDisplayName: string;
    isFromShareholder: boolean;
    message: string;

    constructor(init?: Partial<ChatMessageModel>) {
        super();
        Object.assign(this, init);
    }
}
